export default __webpack_public_path__ + "static/media/cert-fsi-hkgcsmeaa.6f98ac05.jpg";